import { createFileRoute, redirect } from '@tanstack/react-router';

// [2026-06-08] /settings/spend is gone — spend caps were
// modeled as a brand-wide total but the real lever is per-campaign
// (set during campaign creation). Old bookmarks land on /campaigns.
export const Route = createFileRoute('/brand/$slug/settings/spend')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/brand/$slug/campaigns', params: { slug: params.slug } });
  },
});
